var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 15,
    viewBox: "0 0 5 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 11.3635 0.253034 10.753 0.703437 10.3029C1.15384 9.85286 1.76472 9.6 2.40169 9.6C3.03865 9.6 3.64953 9.85286 4.09993 10.3029C4.55034 10.753 4.80337 11.3635 4.80337 12C4.80337 12.6365 4.55034 13.247 4.09993 13.6971C3.64953 14.1471 3.03865 14.4 2.40169 14.4C1.76472 14.4 1.15384 14.1471 0.703437 13.6971C0.253034 13.247 0 12.6365 0 12ZM0 2.4C0 1.76348 0.253034 1.15303 0.703437 0.702944C1.15384 0.252856 1.76472 0 2.40169 0C3.03865 0 3.64953 0.252856 4.09993 0.702944C4.55034 1.15303 4.80337 1.76348 4.80337 2.4C4.80337 3.03652 4.55034 3.64697 4.09993 4.09706C3.64953 4.54714 3.03865 4.8 2.40169 4.8C1.76472 4.8 1.15384 4.54714 0.703437 4.09706C0.253034 3.64697 0 3.03652 0 2.4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.0bddfe05161c45a843ed5d05629483d5.svg";
export { ForwardRef as ReactComponent };